/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateTimeScheduled/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DateTimeScheduled({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/DateTimeScheduled"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentAppointmentBookings0ValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'appointment_bookings[0]',
format: fromFormat.isScheduled,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(appointmentAppointmentBookings0ValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}